import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as additionalInformationAvailableGroupsReducers from '../reducers/additional-information-available-groups.reducers';
import * as additionalInformationReducers from '../reducers/additional-information.reducers';

export const selectAdditionalInformationAvailableGroups = createFeatureSelector<additionalInformationAvailableGroupsReducers.State>('AdditionalInformationAvailableGroups');

export const selectAdditionalInformation = createFeatureSelector<additionalInformationReducers.State>('AdditionalInformation');

export const {
  selectEntities: selectAdditionalInformationAvailableGroupsEntities
} = additionalInformationAvailableGroupsReducers.adapter.getSelectors(selectAdditionalInformationAvailableGroups);

export const {
  selectEntities: selectAdditionalInformationEntities
} = additionalInformationReducers.adapter.getSelectors(selectAdditionalInformation);

export const selectAvailableGroupsByWidgetConfigId = (widgetConfigId: number) =>
  createSelector(selectAdditionalInformationAvailableGroupsEntities, (entities) => entities[widgetConfigId]);


export const getAvailableGroupsLoading = (widgetConfigId: number) =>
  createSelector(selectAvailableGroupsByWidgetConfigId(widgetConfigId),
    (entity: additionalInformationAvailableGroupsReducers.AdditionalInformationAvailableGroupsInstance) => {
      return entity && entity.loading;
    }
  );

export const getAvailableGroups = (widgetConfigId: number) =>
  createSelector(selectAvailableGroupsByWidgetConfigId(widgetConfigId),
    (entity: additionalInformationAvailableGroupsReducers.AdditionalInformationAvailableGroupsInstance) => {
      return entity ? entity.availableGroups : null;
    } 
  );

export const selectUserSelectedGroupsByDashboardId = (dashboardId: number) =>
  createSelector(selectAdditionalInformationEntities, (entities) => entities[dashboardId]);

export const getUserSelectedGroupsLoading = (dashboardId: number) =>
  createSelector(selectUserSelectedGroupsByDashboardId(dashboardId),
    (entity: additionalInformationReducers.AdditionalInformationInstance) => {
      return entity && entity.loading;
    });

export const getUserSelectedGroups = (dashboardId: number) =>
  createSelector(selectUserSelectedGroupsByDashboardId(dashboardId),
    (entity: additionalInformationReducers.AdditionalInformationInstance) => {
      return entity ? entity.userSelectedGroups:null;
    });

export const getAdditionInformationDetails = (dashboardId: number) =>
  createSelector(selectUserSelectedGroupsByDashboardId(dashboardId),
    (entity: additionalInformationReducers.
      AdditionalInformationInstance) => {
      return entity ? entity.details : null;
    });
